// stores 
import * as ProtocolConsumptionStore from '../../../redux/middleware/ProtocolConsumptionMiddleware';
import * as ProtocolStore from '../../../redux/middleware/MedicalProtocolMiddleware';

// state
import { AppState } from '../../../redux/reducers';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';

//#region Props

interface IProps {
    ProtocolId: number;
    ProtocolConsumptionId: string;
}

interface ConnectedProps {
    // loading
    isLoading: boolean;
    successLoading: boolean;
    failLoading: boolean;
    errorOnLoading: string | null;

    // changing amount
    isChangingType: boolean;
    successChangingType: boolean;
    failChangingType: boolean;
    errorOnChangingType: string | null;
    
    Protocol: Protocol | null;
    Consumption: ProtocolConsumption | null;
}

interface MedicalServicesDispatchProps {
    GetProtocolConsumptionById: typeof ProtocolConsumptionStore.ActionCreators.GetProtocolConsumptionById;
    ChangeVisitType: typeof ProtocolConsumptionStore.ActionCreators.ChangeVisitType;
    GetMedicalProtocolById: typeof ProtocolStore.actionCreators.GetMedicalProtocolById;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const auxProtocol: Protocol | null = state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) || null;

    const auxConsumption: ProtocolConsumption | null = auxProtocol?.consumptions?.find((consumption : ProtocolConsumption) =>  consumption.id === ownProps.ProtocolConsumptionId ) || null;
    
    return {
        isLoading: state.MedicalProtocols?.isLoadingOneConsumption || false,
        successLoading: state.MedicalProtocols?.LoadingOneConsumptionSuccess || undefined,
        failLoading: state.MedicalProtocols?.FailGettingOneConsumption || null,
        errorOnLoading: state.MedicalProtocols?.ErrorGettingOneConsumption || null,

        isChangingType: auxConsumption?.isVisitTypeChanging || false,
        successChangingType: auxConsumption?.visitTypeChanged || undefined,
        failChangingType: auxConsumption?.failonVisitTypeChange || null,
        errorOnChangingType: auxConsumption?.ErrorOnVisitTypeChange || null,

        Protocol: auxProtocol,
        Consumption: auxConsumption
    }
};

export const mapDispatchToProps = {
    ...ProtocolConsumptionStore.ActionCreators,
    ...ProtocolStore.actionCreators
};

